export const DESTINATION = 'destination';
export const ROOMS_AND_GUESTS = 'roomsAndGuests';
export const DATES = 'dates';
export const SPECIAL_RATES = 'specialRates';
export const USE_POINTS = 'usePoints';
export const RESET = 'reset';
export const DESTINATION_HIDDEN_FIELDS = 'destinationHiddenFields';
export const LATITUDE_AND_LONGITUDE = 'latitudeAndLongitude';
export const UNIT_OF_ROOM = 'unitOfRoom';
export const ROOM_COUNT_MAP_FOR_JP_LOCALE: Record<number, string> = {
  4: '4〜9',
  10: '10〜25',
  26: '26以上',
};
export const ADF_ROOM_COUNT_MAP: Record<number, string> = {
  4: '4-9',
  10: '10-25',
  26: '26+',
};
